module.exports = __webpack_public_path__ + "img/class_d.78b73a6d.png";